var exports = {
  "Nr": "VoiceActivityCard.module__card___SGtYOE",
  "wu": "VoiceActivityCard.module__headerContextGroup___SGtYOE",
  "U1": "VoiceActivityCard.module__headerRow___SGtYOE",
  "LD": "VoiceActivityCard.module__headerLeft___SGtYOE",
  "mB": "VoiceActivityCard.module__activityLabel___SGtYOE",
  "l1": "VoiceActivityCard.module__streamingLabel___SGtYOE",
  "kf": "VoiceActivityCard.module__contextButton___SGtYOE",
  "kx": "VoiceActivityCard.module__contextChannelName___SGtYOE",
  "fd": "VoiceActivityCard.module__contextIcon___SGtYOE",
  "gE": "VoiceActivityCard.module__actionIcon___SGtYOE",
  "o_": "VoiceActivityCard.module__contextGuildIcon___SGtYOE",
  "pz": "VoiceActivityCard.module__contextChevron___SGtYOE",
  "mr": "VoiceActivityCard.module__contextDmAvatar___SGtYOE",
  "Nu": "VoiceActivityCard.module__participantsRow___SGtYOE",
  "i1": "VoiceActivityCard.module__previewContainer___SGtYOE",
  "n": "VoiceActivityCard.module__previewSubmitting___SGtYOE",
  "FC": "VoiceActivityCard.module__previewHoverOverlay___SGtYOE",
  "oz": "VoiceActivityCard.module__previewImage___SGtYOE",
  "nZ": "VoiceActivityCard.module__previewFallback___SGtYOE",
  "Mp": "VoiceActivityCard.module__previewHoverText___SGtYOE",
  "$l": "VoiceActivityCard.module__actionRow___SGtYOE",
  "hP": "VoiceActivityCard.module__actionButton___SGtYOE",
};

module.exports = exports;
